import { ReactElement } from 'react';
import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

type Props = {
  firstLine: string;
  secondLine: string;
  icon: ReactElement;
};

export const NewsfeedEmptyState = ({ firstLine, secondLine, icon }: Props) => (
  <Column mTop={60} alignItems="center">
    <Column mTop={20} mLeft={40} mBottom={20}>
      {icon}
    </Column>
    <Text14 textAlign="center" themeColor={ThemeColorType.gray} semiBold>
      {firstLine}
      <br />
      {secondLine}
    </Text14>
  </Column>
);
